var _circle, _circle2, _circle3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSwan = function SvgSwan(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 85 85",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 40,
    fill: "#49793f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 37.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#588c5e",
    d: "m36.607 36.254 5.383-9.923-5.179-10.434c-1.381-1.304-2.608-.537-2.992 0L15.252 49.56l8.235-2.078c5.294-1.458 8.286-2.378 13.734.384 0 0 4.757 2.685 11.509.153 0 0 4.987-2.685 10.971-.921l10.166 3.018-5.435-10.511c-4.603-1.381-8.67-3.453-15.421-.614 0 0-6.498 3.258-13.273-.614-1.074-.614-3.299-.921-3.299-.921l2.455-4.373z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#588c5e",
    d: "m37.975 37.501 11.649-21.297c1.919-1.995 3.3-.077 3.3-.077l10.894 21.425c-3.913-1.227-5.697-2.142-11.221-1.221l-1.669-3.018-2.135 3.836c-4.22 1.458-5.831 1.579-10.818.352"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a7cac",
    d: "m14.23 51.701 9.718-2.455c3.913-.997 7.98-1.688 12.429.767 0 0 6.138 2.916 12.045 0 0 0 4.297-2.379 9.898-.921l12.787 3.581 2.762 5.116c.46 1.688-.307 2.801-1.937 2.801l-58.367-.04c-1.765.04-3.069-.997-2.379-2.685l3.044-6.163Z"
  })));
};
export default SvgSwan;